import { jsxs as c, jsx as o, Fragment as u } from "react/jsx-runtime";
import _, { useId as m } from "react";
import { c as f } from "./clsx-OuTLNxxd.js";
import { c as x } from "./createLucideIcon-WU3cnAkb.js";
import './Input.css';/**
 * @license lucide-react v0.367.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */
const E = x("CircleAlert", [
  ["circle", { cx: "12", cy: "12", r: "10", key: "1mglay" }],
  ["line", { x1: "12", x2: "12", y1: "8", y2: "12", key: "1pkeuh" }],
  ["line", { x1: "12", x2: "12.01", y1: "16", y2: "16", key: "4dfq90" }]
]), h = "_Input_yl3fx_32", v = "_error_yl3fx_57", g = "_InputWrapper_yl3fx_64", b = "_ErrorIcon_yl3fx_69", N = "_ErrorMessage_yl3fx_80", r = {
  Input: h,
  error: v,
  InputWrapper: g,
  ErrorIcon: b,
  ErrorMessage: N
}, k = _.forwardRef(
  ({ "aria-describedby": i, "aria-invalid": t, className: d, errors: s, type: l, ...p }, y) => {
    const e = s !== void 0 && s.length > 0, a = `${m()}-error`, I = [i, e ? a : void 0].filter(Boolean).join(" ") || void 0;
    return /* @__PURE__ */ c("div", { className: r.InputWrapper, children: [
      /* @__PURE__ */ o(
        "input",
        {
          "aria-describedby": I,
          "aria-invalid": t ?? (e || void 0),
          className: f(r.Input, e ? r.error : "", d),
          ref: y,
          type: l,
          ...p
        }
      ),
      e && /* @__PURE__ */ c(u, { children: [
        /* @__PURE__ */ o(E, { "aria-hidden": !0, className: r.ErrorIcon }),
        /* @__PURE__ */ o("div", { id: a, children: s.map((n) => /* @__PURE__ */ o("p", { className: r.ErrorMessage, children: n }, n)) })
      ] })
    ] });
  }
);
k.displayName = "Input";
export {
  k as I
};
